export const BrowserUtils = {
  isSafari() {
    return (
      /Safari/.test(navigator.userAgent) &&
      /Apple Computer/.test(navigator.vendor)
    );
  },
  /** iPadOS reports itself as a Mac, so a touch-capable "Mac" is an iPad. */
  isIOS() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  },
};
